<div class="connection-request-container">
  <div class="connection-request">
    <div class="logo">
      <img [src]="vendorLogo" [alt]="vendorName" width="42px" loading="lazy" />
    </div>
    <div class="body">
      <div class="subject">
        <span class="company-name" (click)="companyClick($event)">{{
          vendorName
        }}</span>
        has requested to join the <b>{{ projectName }}</b> project.
      </div>
      <div class="description" *ngIf="requestMessage">
        <b>A note from {{ vendorName }}:</b>
        {{ requestMessage }}
      </div>
      <div class="actions">
        <s-button
          type="secondary"
          skin="red"
          size="small"
          [icon]="
            isDecliningRequest
              ? 'pi pi-spin pi-spinner'
              : isAcceptingRequest
              ? ''
              : 'pi pi-times-circle'
          "
          iconPos="left"
          [label]="'Decline'"
          (click)="declineProject()"
          [disabled]="isAcceptingRequest || isDecliningRequest"
        ></s-button>
        <s-button
          type="primary"
          skin="green"
          size="small"
          [icon]="
            isAcceptingRequest
              ? 'pi pi-spin pi-spinner'
              : isDecliningRequest
              ? ''
              : 'pi pi-check-circle'
          "
          icon="pi pi-check-circle"
          iconPos="left"
          [label]="'Accept'"
          (click)="acceptProject()"
          [disabled]="isAcceptingRequest || isDecliningRequest"
        ></s-button>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>
